import { WeekDay } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';
import { AdminUIHelpers } from '../common/helpers';

@Pipe({
  name: 'timeDateFormat',
  standalone: true,
})
export class TimeDatePipe implements PipeTransform {
  // Example: 8:30 PM | Sun, Jan 8
  public transform(value: Date): string {
    return ensureTimeZone(value).format('LT [|] ddd, MMM D');
  }
}

@Pipe({
  name: 'dateTimeFormat',
  standalone: true,
})
export class DateTimePipe implements PipeTransform {
  // Example: Sun, Jan 8, 2020 | 8:30 PM
  public transform(value: Date): string {
    return ensureTimeZone(value).format('ddd, MMM D, YYYY [|] LT');
  }
}

@Pipe({
  name: 'statusDateTime',
  standalone: true,
})
export class StatusDateTime implements PipeTransform {
  // Example: Jan 8 2020 at 9:31 AM
  public transform(value: Date): string {
    return ensureTimeZone(value).format('MMM D, YYYY [at] LT');
  }
}

@Pipe({
  name: 'shortDate',
  standalone: true,
})
export class ShortDatePipe implements PipeTransform {
  // Example: Jan 1 ...  Feb 26
  public transform(value: Date): string {
    return ensureTimeZone(value).format('MMM D');
  }
}

// Note that this takes in a number as an enum, and is different from the Web team's pipe which took in a real Date
@Pipe({
  name: 'day',
  standalone: true,
})
export class DayPipe implements PipeTransform {
  // Example: Sun Mon ... Fri Sat
  public transform(value: number): string {
    return WeekDay[value];
  }
}

@Pipe({
  name: 'timeOnly',
  standalone: true,
})
export class TimeOnlyPipe implements PipeTransform {
  // Example: 8:30 PM
  public transform(value: Date | moment.Moment): string {
    return ensureTimeZone(value).format('LT');
  }
}

@Pipe({
  name: 'dayDate',
  standalone: true,
})
export class DayDatePipe implements PipeTransform {
  // Example: Tue, Oct 8
  public transform(value: Date): string {
    return ensureTimeZone(value).format('ddd, MMM D');
  }
}

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  public transform(value: Date | moment.Moment, dateFormat: string): any {
    return ensureTimeZone(value).format(dateFormat);
  }
}

@Pipe({
  name: 'overrideTimeView',
  standalone: true,
})
export class OverrideTimeViewPipe implements PipeTransform {
  public transform(value: string): string {
    return AdminUIHelpers.convertHoursOverridesTimeFieldToMoment(value).format('hh:mm A');
  }
}

const ensureTimeZone = (date: Date | moment.Moment): moment.Moment => {
  return moment.tz(date, 'America/New_York');
};
